import { curlGateWay } from '../curl';
/**
 * 获取主题页 cms
 * https://yapi.lifekh.com:8443/project/61/interface/api/99709
 * @param {*} params
 * @param config
 */
export const appConfigCmstopicGetTopicPage = (params, config) => curlGateWay(params, `app/config/cmstopic/getTopicPage`, config);
// export const appConfigCmstopicGetTopicPage = (params, config) => new Promise(re => {
//   const ret = {
//     "rspCd": "00000",
//     "rspInf": "success",
//     "rspType": 0,
//     "data": {
//       "resultCode": "0",
//       "pageNo": "1720323368116006912",
//       "businessLine": "YumNow",
//       "pageStyle": "{\"pageBackground\":\"\",\"pageColor\":\"#EF3232\"}",
//       "pageExpand": "{\"pageCnName\":\"联调页面zh\",\"pageEnName\":\"联调页面en\",\"pageKhName\":\"联调页面kh\",\"pageCnDescription\":\"联调规则说明-zh\",\"pageEnDescription\":\"联调规则说明-en\",\"pageKhDescription\":\"联调规则说明-kh\",\"pageDescriptionStyle\":\"10\",\"pageDescriptionColor\":\"#ffffff\",\"pageDescriptionBgColor\":\"#000000\"}",
//       "modelListInfo": [
//         {
//           "modelContent": "{\"list\":[{\"imageCnUrl\":\"https://image.tinhnow.com/wownow/files/sit/app/MEF/BF/BD/24bf7a1506234d00bd537323a8185017.png?WxH=498x298\",\"imageEnUrl\":\"\",\"imageKhUrl\":\"\",\"jumpUrl\":\"https://www.baidu.com/\"}]}",
//           "modelStyle": "{\"paddingTop\":0,\"paddingLeft\":0,\"paddingRight\":0,\"paddingBottom\":0,\"marginTop\":10,\"marginLeft\":0,\"marginRight\":0,\"marginBottom\":10}",
//           "modelExpand": "{}",
//           "modelName": "cmsImage"
//         },
//         {
//           "modelContent": "{\"titleCnName\":\"标题栏-zh\",\"titleEnName\":\"标题栏-en\",\"titleKhName\":\"标题栏-kb\"}",
//           "modelStyle": "{\"titleColor\":\"#ffffff\",\"textAlign\":\"center\",\"marginTop\":0,\"marginLeft\":0,\"marginRight\":0,\"marginBottom\":0}",
//           "modelExpand": "{}",
//           "modelName": "cmsTitle"
//         },
//         {
//           "modelContent": "{\"activityNoList\":[\"1721411543052251136\"],\"detailData\":[{\"activityNo\":\"1721411543052251136\",\"activityName\":\"用户自选CMS1\",\"description\":\"用户自选CMS1\",\"beginTime\":\"2023.11.08\",\"endTime\":\"2023.11.16\",\"activityStartTime\":1699376400000,\"activityEndTime\":1700067600000,\"status\":{\"code\":10,\"message\":\"未开始\"},\"daysLeft\":2,\"couponList\":[{\"couponNo\":\"WNJ230620103456939\",\"usableBusinessLine\":[\"YumNow\"],\"beginDate\":null,\"endDate\":null,\"fixedTerm\":5,\"fixedBeginTerm\":1,\"thresholdAmountUsd\":{\"cent\":0,\"currency\":\"CNY\",\"md5\":null,\"rsa\":null,\"centFactor\":100,\"amount\":0},\"couponAmt\":\"9.00\",\"couponTitle\":\"Store Coupon：youhui\",\"businessLine\":\"YUMNOW\",\"discountType\":{\"code\":10,\"message\":\"固定金额\"},\"preferRatio\":null,\"preferLimitUsd\":null,\"fixedType\":{\"code\":10,\"message\":\"天\"},\"stockNum\":18,\"couponType\":{\"code\":15,\"message\":\"现金券\"}},{\"couponNo\":\"WNJ230717154956106\",\"usableBusinessLine\":[\"YumNow\"],\"beginDate\":null,\"endDate\":null,\"fixedTerm\":2,\"fixedBeginTerm\":1,\"thresholdAmountUsd\":{\"cent\":0,\"currency\":\"CNY\",\"md5\":null,\"rsa\":null,\"centFactor\":100,\"amount\":0},\"couponAmt\":\"2.00\",\"couponTitle\":\"领取后2天可用\",\"businessLine\":\"YUMNOW\",\"discountType\":{\"code\":10,\"message\":\"固定金额\"},\"preferRatio\":null,\"preferLimitUsd\":null,\"fixedType\":null,\"stockNum\":10,\"couponType\":{\"code\":15,\"message\":\"现金券\"}}],\"couponReceiptStatus\":null,\"channel\":{\"code\":113,\"message\":\"用户自选\"}}]}",
//           "modelStyle": "{\"cardType\":\"10\",\"marginTop\":0,\"marginBottom\":0}",
//           "modelExpand": "{}",
//           "modelName": "cmsCoupon"
//         },
//         {
//           "modelContent": "{\"loadType\":\"IMPORT\",\"cmsCardType\":\"PRODUCT\",\"cardId\":21,\"relData\":[],\"goodsNum\":2,\"storeNum\":1}",
//           "modelStyle": "{\"cardType\":\"11\",\"groupStatus\":\"10\",\"sortStatus\":\"10\",\"loadType\":\"10\",\"pageNum\":2}",
//           "modelExpand": "{}",
//           "modelName": "cmsGoods"
//         },
//         {
//           "modelContent": "{\"loadType\":\"IMPORT\",\"cmsCardType\":\"STORE\",\"cardId\":22,\"relData\":[],\"storeNum\":1}",
//           "modelStyle": "{\"cardType\":\"10\",\"groupStatus\":\"10\",\"sortStatus\":\"10\",\"loadType\":\"10\",\"pageNum\":2}",
//           "modelExpand": "{}",
//           "modelName": "cmsStore"
//         }
//       ]
//     },
//     "v": "1",
//     "responseTm": "20231108142002"
//   }
//   config?.success(ret.data);
//   re(ret)
// });

export const queryCityByGeo = (params, config) => curlGateWay(params, `takeaway-merchant/app/super-app/query-city-by-geo`, config);
